import { Button, ListSubheader, Menu, MenuItem, Tooltip, Typography } from "@mui/material";
import { useState } from "react";
import type { DraggableMetaType } from "../../../../../../../../api/types/svTypes.ts";
import { getEligibleFieldDestinations } from "./fieldDestinationStore.ts";
import { useFieldDestination } from "./useFieldDestination.ts";

const TOOLTIP_DELAY_MS = 300;

interface Props {
  field: DraggableMetaType;
}

const FieldTreeAddButton = ({ field }: Props) => {
  const destinations = useFieldDestination();
  const { store, destination } = destinations;
  const [anchorEl, setAnchorEl] = useState<HTMLElement>();
  const eligibleDestinations = getEligibleFieldDestinations(destinations, field);
  const singleDestination = eligibleDestinations.length === 1 ? eligibleDestinations[0] : undefined;

  if (eligibleDestinations.length === 0) {
    return null;
  }

  return (
    <>
      <Tooltip
        arrow
        disableInteractive
        enterDelay={TOOLTIP_DELAY_MS}
        enterNextDelay={TOOLTIP_DELAY_MS}
        title={singleDestination ? `Add to ${singleDestination.title}` : ""}
      >
        <Button
          className={!destination && !anchorEl ? "add-field-action" : undefined}
          variant="text"
          color="secondary"
          aria-label={singleDestination ? `Add ${field.caption} to ${singleDestination.title}` : `Add ${field.caption}`}
          aria-haspopup={singleDestination ? undefined : "menu"}
          aria-expanded={singleDestination ? undefined : !!anchorEl}
          sx={{ minWidth: 40, height: 28, flexShrink: 0, py: 0, px: 1, my: -0.5, ml: 0.5 }}
          onClick={(event) => {
            event.stopPropagation();
            if (singleDestination) {
              store?.addField(field, singleDestination.id);
            } else {
              setAnchorEl(event.currentTarget);
            }
          }}
        >
          <Typography component="span" variant="caption">
            Add
          </Typography>
        </Button>
      </Tooltip>
      {!singleDestination && anchorEl && (
        <Menu open anchorEl={anchorEl} onClose={() => setAnchorEl(undefined)}>
          <ListSubheader sx={{ pb: 0.25 }}>Add to</ListSubheader>
          {eligibleDestinations.map((item) => (
            <MenuItem
              key={item.id}
              onClick={(event) => {
                event.stopPropagation();
                store?.addField(field, item.id);
                setAnchorEl(undefined);
              }}
            >
              {item.title}
            </MenuItem>
          ))}
        </Menu>
      )}
    </>
  );
};

export default FieldTreeAddButton;
